export const friends = {
  Friend: "친구",
  FriendList: "친구 목록",
  AddFriend: "친구 추가",
  AddFriendDesc: "친구를 추가합니다.",
  AddFriendRequest: "{name}님을 친구로 추가하시겠습니까?",
  RemoveFriend: "친구 삭제",
  RemoveFriendDesc: "친구를 삭제합니다.",
  AcceptFriend: "친구 승인",
  AcceptFriendDesc: "친구 요청을 승인합니다.",
  CancelFriend: "친구 취소",
  CancelFriendDesc: "친구 요청을 취소합니다.",
  ManageFriend: "친구 관리",
  SearchUser: "사용자 검색",
  SearchUserPlaceHolder: "이름 또는 이메일로 검색",
  SentRequests: "보낸 요청",
  ReceivedRequests: "받은 요청",
  SendWhisper: "속삭임 보내기",
  SendWhisperDesc:
    "속삭임은 서버에 저장되지 않고 상대방에게 직접 전달되는 메시지입니다.",
  LastSeen: "마지막 접속",
} as const;
